import React, { Component } from "react";
import {setTitle} from '../../../utils/utils';
import styles from './index.less';
export default class ProcessInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {} 
    setTitle('使用过程信息');
  }

  componentDidMount() {

  }

  openPage = (page) => {
    let countParams = this.props.location.query;
    console.log('333', countParams)
    let url =  `/${page}`;
    console.log('openPage----params---', page);
    if (page === 'locationInfo') {
      url = url + `?orderCount=${countParams.orderCount}`;
    } else {
      url = url + `?authCount=${countParams.authCount}&receiptCount=${countParams.receiptCount}`;
    }
    this.props.history.push(url);
  }

  render() {
    return (
      <div className={styles.processInfo}>
        <div className="card">
            <b className="title">位置信息</b>
            <div className="list"><div className="label">使用目的</div><div className="info">完成下单</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户下单选择装货地、卸货地地址使用地图功能时</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => this.openPage('locationInfo')}>收集位置信息</div></div>
        </div>
        <div className="card">
            <b className="title">图片信息</b>
            <div className="list"><div className="label">使用目的</div><div className="info">身份验证；上传回单</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户完成企业认证；上传回单时</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => this.openPage('imageInfo')}>图片信息</div></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/processInfo/index.js